import { useContext, useEffect, useState } from 'react';

import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { RcnUserContext } from 'src/context/RcnUser/RcnUserContext';

import { FetchState } from 'src/enums/FetchState';

import { favouritesRequest } from 'src/services/favourites/favouritesRequest';
import { favouriteUpdate } from 'src/services/favourites/favouriteUpdate';

import { Button } from 'src/components/basicContent/_Button/Button';

import StarSvg from 'public/icons/star.svg';
import StarOutlineSvg from 'public/icons/StarOutline.svg';

import styles from './_Favourite.module.css';

export type FavouriteProps = {
	itemId: string;
	showText: boolean;
	favouriteButtonText: Field<string>;
	favouriteButtonToolTip?: Field<string>;
	unfavouriteText: Field<string>;
	toolbarIconSize?: boolean;
};

export function Favourite(props: FavouriteProps): JSX.Element {
	const RcnUser = useContext(RcnUserContext);
	const [isFavourite, setIsFavourite] = useState(false);

	useEffect(() => {
		setIsFavourite(RcnUser.userFavourites !== undefined && RcnUser.userFavourites.includes(props.itemId));
	}, [props.itemId, RcnUser.userFavourites]);

	if (!RcnUser.authenticatedUserProfile) {
		return <></>;
	}

	const text = isFavourite ? props.unfavouriteText?.value : props.favouriteButtonText?.value;

	async function toggleFavourite() {
		const responseState = await favouriteUpdate(props.itemId, isFavourite);

		if (responseState !== FetchState.SUCCESS) {
			return alert('Something went wrong');
		}

		setIsFavourite(!isFavourite);

		const { data } = await favouritesRequest();
		RcnUser.updateUserFavourites(data);
	}

	return (
		<div>
			<Button
				title={props.favouriteButtonToolTip?.value}
				className={`${styles.favouriteButton} link linkOffset linkHoverWeighted`}
				onClick={toggleFavourite}
			>
				<span>
					{isFavourite ? (
						<StarSvg alt={text} className={props.toolbarIconSize ? styles.toolbarFavouriteIcon : styles.favouriteIcon} />
					) : (
						<StarOutlineSvg alt={text} className={props.toolbarIconSize ? styles.toolbarFavouriteIcon : styles.favouriteIcon} />
					)}{' '}
					{props.showText && <span>{text}</span>}
				</span>
			</Button>
		</div>
	);
}
